module.exports = __webpack_public_path__ + "img/accident_turn_over.b123bffb.svg";